export default __webpack_public_path__ + "static/media/manual20.b1321cf7.png";